var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:'image-size-'+_vm.block.attributes.sizeSlug,style:({
	maxWidth: _vm.block.attributes.width ? _vm.block.attributes.width + 'px' : 'auto',
	maxHeight: _vm.block.attributes.height ? _vm.block.attributes.height + 'px' : 'auto',
}),attrs:{"src":_vm.block.attributes.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }